import React from "react";
import {
    Box,
    Card,
    CardContent,
    Divider,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from "../../utility/helper";

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
}));

const TicketAccordianCard = (props) => {
    const clasess = useStyles();
    const { classes, item } = props;
    const ticketInfo = item.actualData;
    // const bowlData = JSON.parse(item.actualData.ticketJSON);
    // const [upperBowlCount, setUpperBowlCount] = React.useState()
    // const [lowerBowlCount, setLowerBowlCount] = React.useState()
    // const [upperBowlCost, setUpperBowlCost] = React.useState()
    // const [lowerBowlCost, setLowerBowlCost] = React.useState()

    React.useEffect(() => {
        // let upperData = [];
        // let lowerData = [];
        // let upperCostData = [];
        // let upperCost = 0;
        // let lowerCostData = []
        // let lowerCost = 0
        // bowlData.filter(item => item.TicketType === "Upper Bowl").map(filteredData =>
        // {
        //     upperData.push(filteredData);
        //     upperCostData.push(parseInt(filteredData.TicketPrice));
        // })
        // bowlData.filter(item => item.TicketType === "Lower Bowl").map(filteredData =>
        // {
        //     lowerData.push(filteredData);
        //     lowerCostData.push(parseInt(filteredData.TicketPrice));

        // })

        // for (let i = 0; i < upperCostData.length; i++)
        // {
        //     upperCost += upperCostData[i];
        // }
        // for (let i = 0; i < lowerCostData.length; i++)
        // {
        //     lowerCost += lowerCostData[i];
        // }
        // setUpperBowlCost(upperCost)
        // setLowerBowlCost(lowerCost)
        // setUpperBowlCount(upperData);
        // setLowerBowlCount(lowerData)

    }, [])
    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: "none" }} >
                <CardContent className={clasess.cardContent}>
                    <Box className={classes.rowContent}>
                        <Box sx={{
                            width: '100px',
                            flexBasis: '100px',
                            flexGrow: 1,
                            overflow: 'hidden',

                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Ticket Contact Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{ticketInfo.receipentName}</span>
                                    {/* <br /> */}
                                    {/* <span><a */}
                                        {/* href={`mailto:${ticketInfo.receipentEmail}`}>
                                        {' '}
                                        {ticketInfo.receipentEmail}{' '}
                                    </a></span> */}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{
                            width: '100px',
                            flexBasis: '100px',
                            flexGrow: 1,
                            overflow: 'hidden',

                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Ticket Contact Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {ticketInfo.receipentEmail}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>

                        {/* {(upperBowlCount && upperBowlCount.length != 0) ?
                            <Box sx={{
                                width: '50px',
                                flexBasis: '50px',
                                flexGrow: 1,

                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center'
                                    }}>
                                    <Box>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Upper Bowl
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}>
                                            <span>{upperBowlCount.length != 0 ? JSON.stringify(upperBowlCount.length) : ''}</span>
                                        </Typography>
                                    </Box>
                                </Box>

                            </Box> : ""}
                        {(upperBowlCost && upperBowlCost != 0) ?
                            <Box sx={{
                                width: '50px',
                                flexBasis: '50px',
                                flexGrow: 1,

                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center'
                                    }}>
                                    <Box>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Upper Bowl Cost
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}>
                                            <span>{upperBowlCost != 0 ? JSON.stringify(upperBowlCost) : ''}</span>
                                        </Typography>
                                    </Box>
                                </Box>

                            </Box> : ""}
                        {(lowerBowlCount && lowerBowlCount.length != 0) ?
                            <Box sx={{
                                width: '50px',
                                flexBasis: '50px',
                                flexGrow: 1,

                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center'
                                    }}>
                                    <Box>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Lower Bowl
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}>
                                            <span>{lowerBowlCount.length != 0 ? JSON.stringify(lowerBowlCount.length) : ''}</span>
                                        </Typography>
                                    </Box>
                                </Box>

                            </Box> : ""}
                        {(lowerBowlCost && lowerBowlCost != 0) ?
                            <Box sx={{
                                width: '50px',
                                flexBasis: '50px',
                                flexGrow: 1,

                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center'
                                    }}>
                                    <Box>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Lower Bowl Cost
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}>
                                            <span>{lowerBowlCost != 0 ? JSON.stringify(lowerBowlCost) : ''}</span>
                                        </Typography>
                                    </Box>
                                </Box>

                            </Box> : ""} */}


                        {/* </Box>
                    <Box className={classes.rowContent} sx={{ pt: 1 }}> */}
                        <Box sx={{
                            width: '100px',
                            flexBasis: '100px',
                            flexGrow: 1,

                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Ticket Contact Number
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                >
                                    <span>{ticketInfo.receipentContact}</span>
                                </Typography>
                            </Box>
                        </Box>
                        {(ticketInfo.modifyByName !== "" && ticketInfo.modifyByName !== null) ?
                            <Box sx={{
                                width: '100px',
                                flexBasis: '100px',
                                flexGrow: 1,

                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Modified By
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{ticketInfo.modifyByName}</span>
                                    </Typography>
                                </Box>
                            </Box> : ""}
                        {(ticketInfo.modifyDate !== "" && ticketInfo.modifyDate !== null) ?
                            <Box sx={{
                                width: '100px',
                                flexBasis: '100px',
                                flexGrow: 1,

                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Modified On
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{Helper.FormatDateTime(ticketInfo.modifyDate)}</span>
                                    </Typography>
                                </Box>
                            </Box> : ""}
                    </Box>
                </CardContent>
            </Card>
        </>
    )
}

export default TicketAccordianCard;